import { useContext } from 'react';
import { CanvaContext } from './CanvaContext';

export const useCanvaSettings = () => {
  const canvaContext = useContext(CanvaContext);

  if (!canvaContext) {
    throw new Error('useCanvaSettings has to be used within <CanvaContext.Provider>');
  }

  return canvaContext;
};
